import PropTypes from 'prop-types';

const ContactJoined = {
  name: PropTypes.string,
  locationName: PropTypes.string,
  phoneNumber: PropTypes.string,
  joinedAt: PropTypes.string,
};

export const ContactJoinedShape = PropTypes.shape(ContactJoined);
export const ContactJoinedExact = PropTypes.exact(ContactJoined);
